var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_wrapper"},[_c('LoadingIndicator',{staticClass:"primary big"}),_c('ErrorPopup',{attrs:{"show":_vm.auth_error,"popup_header":_vm.error_title,"popup_description":_vm.error_description},on:{"closeEvent":_vm.PopupCloseEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }